export type SignupMode = 'PRIVATE' | 'OPEN' | 'APPROVAL' | 'APPROVAL_EXCEPT_MEMBERS';
export type WaitlistReason = 'APPROVAL_REQUIRED' | 'LIMIT_REACHED';

// WAITLIST means two different waits, and the API says which one. An API that
// predates the reason leaves it empty — then a full kolejka is the better guess.
export function waitlistReasonOf(
  reason: string | null | undefined,
  seatsFull: boolean
): WaitlistReason {
  if (reason === 'APPROVAL_REQUIRED' || reason === 'LIMIT_REACHED') {
    return reason;
  }

  return seatsFull ? 'LIMIT_REACHED' : 'APPROVAL_REQUIRED';
}

export function isPublicSignupMode(signupMode: SignupMode | null | undefined): boolean {
  return signupMode != null && signupMode !== 'PRIVATE';
}

// Mirrors the API rule: pairing does not end signups, activation does.
export function isSignupStage(roundStatus: string | null | undefined): boolean {
  return roundStatus === 'REGISTRATION' || roundStatus === 'GROUPING';
}

// Once the kolejka is under way nobody joins it any more, so both the sign-up list
// and the sign-up-mode hints stop being news — the table and the results take over.
export function signupsStillMatter(roundStatus: string | null | undefined): boolean {
  return roundStatus !== 'ACTIVE' && roundStatus !== 'CLOSED';
}

export function buildRoundStateMessage(
  roundStatus: string | null,
  signupMode: SignupMode | null,
  hasInviteCode = false
): string | null {
  switch (roundStatus) {
    case 'DRAFT':
      return 'Kolejka jeszcze nieopublikowana — wróć gdy organizator otworzy zapisy';
    case 'REGISTRATION':
      if (signupMode === 'PRIVATE') {
        if (hasInviteCode) {
          return 'Masz link z kodem — zapisy poniżej są dla ciebie otwarte';
        }

        return 'Zapisy prywatne — skontaktuj się z organizatorem';
      }

      if (signupMode === 'APPROVAL') {
        return 'Zapisy wymagają akceptacji organizatora';
      }

      if (signupMode === 'APPROVAL_EXCEPT_MEMBERS') {
        return 'Zapisy wymagają akceptacji organizatora — uczestnicy ligi dołączają od razu';
      }

      return 'Zapisy otwarte — dołącz poniżej';
    case 'GROUPING':
      if (signupMode === 'PRIVATE' && !hasInviteCode) {
        return 'Organizator układa pary — zapisy prywatne, skontaktuj się z nim';
      }

      return 'Organizator układa już pary, ale zapisy wciąż są otwarte — dołącz poniżej';
    case 'ACTIVE':
      return 'Kolejka w trakcie — wyniki spływają na żywo';
    case 'CLOSED':
      return null;
    default:
      return null;
  }
}
